/**
 *  유저 리스트 필터 옵션 모델
 */
import { UserListFilterOptionType, TableSortOptionType } from '../types/options';
import { PaginationType } from '../../../../../../types/common/options';

export const ACCOUNT_USER_LIST_FILTER_OPTION_MODEL: UserListFilterOptionType = {
  id: null,
  status: null,
  loginType: null,
  name: null,
  account: null,
  cellPhone: null,
  email: null,
  referralCode: null,
  smsReceive: null,
  grade: null,
  fromCreateDate: null,
  toCreateDate: null,
};

export const ACCOUNT_USER_LIST_SORT_OPTION_MODEL: TableSortOptionType[] = [
  {
    id: 'createDate',
    desc: true,
  },
];

export const LIST_PAGINATION_MODEL: Pick<PaginationType, 'pageNum' | 'pageSize'> = {
  pageNum: 0,
  pageSize: 100,
};
